import React from "react";

//package import

import { ActionCableProvider } from "react-actioncable-provider";
//user import

import { MinistryLayout } from "../../layouts";
import { ministry_Context } from "../../context";
import { StorageKeys } from "../../Services/Storage";
import { API_WS_ROOT } from "../../Services/Routes/API";

//portal

const MinistryAdminPortal = (props) => {
	//hooks

	//constants

	const Provider = ministry_Context.Provider;

	//states
	const token = localStorage.getItem(StorageKeys?.token);
	//render

	return (
		<Provider
			value={{
				user: { ...token },
			}}
		>
			<ActionCableProvider url={API_WS_ROOT + `?token=${token}`}>
				<MinistryLayout {...props} />
			</ActionCableProvider>
		</Provider>
	);
};

export default MinistryAdminPortal;
